/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, {useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import styles from "./styles.css";
import IconHeart from "../../shared/icon-heart/component";
import WhiteTickIcon from "./images/white-tick.svg";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import TransparentButton from "../../shared/button/transparent-button";
import InfoIcon from "./images/info_white.svg";
import {  showNewTestDriveVariant, showTestDriveVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { getTestDriveCtaText } from "../../../utils/helpers/get-test-drive-cta-text";
import { ORDER_STATUS } from "../../../constants/checkout-constants";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { getTestDriveV2CheckoutURL } from "../../../utils/helpers/get-detail-page-url";
import { testDriveV2Routes } from "../../../constants/au.desktop/test-drive-v2-routes";
import { getFullCarName, getPersonalisedTooltipInfoList, getTooltipInfoList } from "../../../utils/helpers/car-properties";
import Tooltip from "../../shared/tooltip";
import Routes from "../../../constants/routes-constant";
import ArrowIcon from "../../shared/arrow";
import { getCarPrice } from "../../../utils/helpers/calculate-egc-dap";
import { AB_TEST_VARIATIONS, ORDER_TYPE } from "../../../constants/app-constants";
import useUserGeoLocation from "../../../hooks/use-user-geo-location";
const CarDetailStickyViewRevamp = ({
    content,
    ctaProps = {},
    isWishlisted,
    onWishlistClick,
    canFavourite = true,
    userTradeInData,
    tradeInToggleSelected,
    order,
    isUserZeroDpVariant,
    source,
    isLoggedIn,
    createOrderConnect,
    personalDetails,
    updateProfileConnect,
    secureToken,
    orderId,
    testDriveConfig
    // comingSoon
}) => {

    const history = useHistory();

    const {
        appointmentId,
        emiDetails,
        price,
        egc,
        estimatedPrice = 0,
        personalised
    } = content || {};

    const [toolTipTitle, setToolTipTitle] = useState("");
    const [toolTipBody, setToolTipBody] = useState([]);
    const { tradeIn = false } =  userTradeInData || {};
    const {testDriveStatus = ""} = order || {};

    const userGeoData = useUserGeoLocation();
    const { state: { name: userState = {}} = {}, country: { isoCode: countryCode } = {}} = userGeoData || {};
    const isTestDriveVariant = showTestDriveVariant({ content, order });
    const {eligibleStateNames = [], enabledForIndia: isTestDriveEnabledForIndia = false} = testDriveConfig?.data || {};
    const isNewTestDriveLocationVariant = showNewTestDriveVariant({ content, order, userState, countryCode, isTestDriveEnabledForIndia, eligibleStateNames});
    const carName = getFullCarName(content);
    const { emiPerWeek } = emiDetails || {};

    const handleGetPreApprovalClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        history.push(Routes.get_pre_approval);
    };
    const BottomLink = () => {
        return (
            <div
                styleName={"styles.financeBottomLink"}>
                <span>Want to know your exact finance rates?</span>
                <Button text="GET PRE-APPROVAL" leftImage={WhiteTickIcon} onClick={handleGetPreApprovalClick} btnView="new" />
                <small>No impact on your credit score</small>
            </div>
        );
    };
    useEffect(() => {
        if (personalised) {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getPersonalisedTooltipInfoList(emiDetails));
        } else {
            setToolTipTitle(`Weekly payment of ${makePriceLabelRound(emiPerWeek)}`);
            setToolTipBody(getTooltipInfoList(emiDetails, isUserZeroDpVariant).concat(<BottomLink />));
        }
    }, [emiPerWeek, emiDetails, personalised, isUserZeroDpVariant]);
    const displayIcon = () => {
        if (!ctaProps.iconType) {
            return (null);
        } else if (ctaProps.iconType === "Info") {
            return (
                <div
                    styleName={"styles.infoicon"}>
                    {<div styleName={"styles.hovertext"}>
                        <img src={InfoIcon} alt={InfoIcon}/>
                        <div styleName={"styles.paratext styles.top_arrow"}>
                            <p>You can choose to be notified if this car becomes available to purchase in the near future</p>
                        </div>
                    </div>}
                </div>);
        } else {
            return (<div styleName={"styles.iconHeart"}>
                { canFavourite &&
                    <IconHeart
                        active={isWishlisted}
                        onClick={onWishlistClick}
                        source="cdp_revamp"
                        customStyle={["outer-revamp"]}
                    />
                }
            </div>);
        }
    };
    const getProfilePayload = () => {
        const { firstName, lastName } = personalDetails || {};
        return {
            ...personalDetails,
            firstName: firstName ?  firstName.trim() : "",
            lastName: lastName ? lastName.trim() : ""
        };
    };
    const updateProfile = async (payload) => {
        try {
            await updateProfileConnect(payload, secureToken);
        } catch (error) {
            throw error;
        }
    };
    const onClickTestDriveV2 = async () => {
        let redirectUrl = "";
        if (testDriveStatus === ORDER_STATUS.BOOKED) {
            const {relativeURL: bookingConfirmationRoute} = getTestDriveV2CheckoutURL(content, testDriveV2Routes.bookingConfirmed.route);
            redirectUrl = bookingConfirmationRoute;
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_CTA_SELECTED, {
                eventLabel: "track_booking",
                eventAction: "cta_selected"
            });
        } else {
            //* Should be fired before "purchase started" event inside createOrderConnect(orderPayload) below
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_CTA_SELECTED, {
                eventLabel: "test_drive",
                eventAction: "cta_selected"
            });
            if (isLoggedIn) {
                const orderPayload = {
                    vehiclePrice: getCarPrice({egcPrice: content.egc, dapPrice: content.price }).egc.value,
                    appointmentId,
                    orderType: ORDER_TYPE.PRODUCT_TEST_DRIVE,
                    tdUserType: AB_TEST_VARIATIONS.TEST
                };
                const  profilePayload  = getProfilePayload();
                try {
                    if (orderId) {
                        await updateProfile(profilePayload);
                    } else {
                        await createOrderConnect(orderPayload);
                    }
                } catch (error) {
                    // console.log(error)
                }
            }
            const { relativeURL: basicDetailsRoute } = getTestDriveV2CheckoutURL(content, testDriveV2Routes.basicDetails.route);
            redirectUrl = basicDetailsRoute;
        }
        history.push(redirectUrl);
    };
    const handleBackClick = () => {
        history.goBack();
    };
    const onClickFinanceInfo = () => {
    };
    return (
        <div styleName={"styles.wrapper"}>
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-5"} styleName="styles.headerColumn">
                        {source === "gallery" && <span onClick={handleBackClick} styleName="styles.backArrow" ><ArrowIcon rotateBy={180}/></span>}
                        <div styleName={"styles.carName"}>
                            <h2 styleName="styles.carFullName">{carName}<span /></h2>
                            <div styleName="styles.carPriceWrapper">

                                <div styleName={"styles.price"}>
                                    <h3 styleName="styles.priceAmount">{(tradeIn && tradeInToggleSelected) ? makePriceLabelRound(estimatedPrice) : makePriceLabelRound(egc || price)}</h3>
                                    <p>{egc ? "Excl. Govt. Charges" : "Drive away price"}</p>
                                </div>
                                <div styleName={"styles.emiPrice"}>
                                    <h3 styleName="styles.emiPriceAmount">{makePriceLabelRound(emiPerWeek)}/week</h3>
                                    <div styleName="styles.financeInfoTooltip">
                                        <Tooltip showOnHover={true} customStyleHeading={true} heading={toolTipTitle} body={toolTipBody} onClickCallback={onClickFinanceInfo}>
                                            <img styleName="styles.financeInfoTooltipIcon" height={13} width={13} src={InfoIcon} alt="Weekly Payment" />
                                        </Tooltip>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"col-7"}>
                        <div styleName={"styles.carButtonWrapper"}>
                            {displayIcon()}
                            <div styleName={"styles.ctaWrapper"}>
                                {ctaProps.transparentButton ?
                                    <div styleName="styles.transparentBtnWrapper">
                                        <TransparentButton
                                            text={ctaProps.text}
                                            disabled={ctaProps.disabled}
                                            onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS, e)}
                                            customStyle={["cdpSticky"]}
                                        />
                                    </div> :
                                    <React.Fragment>
                                        {(isNewTestDriveLocationVariant && !isTestDriveVariant) &&
                                        <div styleName="styles.transparentBtnWrapper">
                                            <TransparentButton
                                                text={getTestDriveCtaText(ORDER_STATUS[testDriveStatus])}
                                                disabled={ctaProps.disabled}
                                                isLoading={ctaProps.isLoading}
                                                onClick={onClickTestDriveV2}
                                                customStyle={["cdpSticky"]}
                                            />
                                        </div>}
                                        <div styleName="styles.btnWrapper">
                                            <Button
                                                text={ctaProps.text}
                                                disabled={ctaProps.disabled}
                                                onClick={(e) => ctaProps.action(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS, e)}
                                            />
                                        </div>

                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

CarDetailStickyViewRevamp.propTypes = {
    content: PropTypes.object,
    ctaProps: PropTypes.object,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    isWishlisted: PropTypes.bool,
    canFavourite: PropTypes.bool,
    comingSoon: PropTypes.bool,
    userTradeInData: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    order: PropTypes.object,
    isUserZeroDpVariant: PropTypes.bool,
    source: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    createOrderConnect: PropTypes.func,
    personalDetails: PropTypes.object,
    updateProfileConnect: PropTypes.func,
    secureToken: PropTypes.string,
    orderId: PropTypes.string,
    testDriveConfig: PropTypes.object
};

export default CarDetailStickyViewRevamp;
